import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAnatomicMap } from '@se/ui.anatomic.map';
import { ServerRootService } from '@se/platform';
import { Logger } from '@se/se.platform.base';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class MultiStageMapLoaderService {
    private path: string;

    private devMode : boolean;
    private valid : boolean = true;

    constructor(private http: HttpClient, private logger: Logger, private serverRoot: ServerRootService) {
        const customPagesSiteRoot : string = this.serverRoot.getCustomPagesSiteRoot();
        this.path = customPagesSiteRoot + 'maps/';
    }

    load(filename: string): Observable<IAnatomicMap> {
        return this.http.get<IAnatomicMap>(this.path + filename + '.json').pipe(
            map (res => {
                res.pathImg = res.pathImg ? this.path + res.pathImg : undefined;
                return res;
            }),
            catchError( error => {
                this.logger.warn('MultiStageMapLoaderService-impossibile caricare la mappa, caricata', error);
                const emptyMap: IAnatomicMap = {
                    segmentCollection: undefined
                };
                return of(emptyMap);
            })
        );
    }
}
